<template>
  <Modal ref="modal" :title="title" @cancel="close">
    <form class="modal-container" @submit.prevent="handleSubmit">
      <Textarea legend="Observação" @update:modelValue="$event => (this.observacao = $event)" :modelValue="observacao"
        :disabled="loading" />

      <div class="buttons">
        <Button @handle:click="close" text="Cancelar" color="danger" :disabled="loading" />
        <Button type="submit" text="Confirmar" color="primary" :disabled="loading" />
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Textarea from 'core/Textarea'
import Button from 'core/Button'

export default {
  name: 'GiveFreeModal',
  components: {
    Modal,
    Textarea,
    Button,
  },
  data() {
    return {
      schema: '',
      faturaId: '',
      status: '',
      title: '',
      observacao: '',
      temporarily: false,
      loading: false,
    }
  },
  methods: {
    open(title, schema, id, status, temporarily = false) {
      this.title = title
      this.schema = schema
      this.faturaId = id
      this.status = status
      this.temporarily = temporarily

      this.$refs.modal.open()
    },
    close() {
      this.title = ''
      this.schema = ''
      this.faturaId = ''
      this.observacao = ''
      this.loading = false

      this.$refs.modal.close()
    },
    async handleSubmit() {
      if (this.faturaId && this.schema) {
        if (!this.observacao) {
          this.$toasted.show('A observação é obrigatória!', {
            position: 'top-right'
          })

          return
        }

        this.loading = true

        const data = {
          schema: this.schema,
          fatura_id: this.faturaId,
          status: this.status,
          observation: this.observacao,
          temporarily: this.temporarily,
        }

        await this.$http.put(`${process.env.VUE_APP_URL_API_V2}/faturamento/atualizar/gratuidade`, data)
          .then(res => {
            this.$toasted.show(res.body.mensagem, {
              position: 'top-right'
            })
          })
          .catch(err => {
            this.$toasted.show(err.body.mensagem, {
              position: 'top-right'
            })
          })
          .finally(() => {
            this.loading = false

            this.close()

            this.$emit('updated')
          })
      } else {
        this.$toasted.show('Fatura não encontrada!', {
          position: 'top-right'
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  width: 40vw;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .buttons {
    display: flex;
    gap: 0.25rem;

    button {
      flex: 1;
      justify-content: center;
    }
  }
}
</style>